import React from 'react';

const InputBox = ({
  text,
  icon,
  name,
  id,
  options,
  value,
  date,
  last,
  setFlight,
}) => {
  const convertDate = (date) => {
    let newDate = date.split('-');
    return `${newDate[2]}-${newDate[1]}-${newDate[0].slice(-2)}`;
  };

  const handleChange = (e) => {
    setFlight((flight) => {
      if (name === 'date') {
        return {
          ...flight,
          [name]: convertDate(e.target.value),
        };
      } else {
        return {
          ...flight,
          [name]: e.target.value,
        };
      }
    });
  };

  return (
    <div className={`${last ? 'des-from !border-r-0' : 'des-from'}`}>
      <p>{text}</p>
      {date ? (
        <input
          type="date"
          className="outline-none px-2 py-2 w-full date"
          name={name}
          id={id}
          required
          onChange={handleChange}
        />
      ) : (
        <div className="flex flex-row">
          <img src={icon} alt="" />
          <select
            className="outline-none px-2 py-2 w-full"
            name={name}
            id={id}
            required
            onChange={handleChange}
          >
            <option value="" hidden>
              Please Select
            </option>
            {options.map((text, idx) => {
              return value ? (
                <option key={idx} value={value[idx]}>
                  {text}
                </option>
              ) : (
                <option key={idx} value={text}>
                  {text}
                </option>
              );
            })}
          </select>
        </div>
      )}
    </div>
  );
};

export default InputBox;
